<template>
  <div class="SearchResponsesItemChatText">
    <div v-for="text in textList" :key="text.value">
      <div v-if="text.type === 'text' || text.type === 'translation'">
        <ForumResponseBodyTextOutput class="SearchResponsesItemChatContext__text" :text="text.value" />
      </div>
      <div v-else-if="text.type === 'transcription'">
        <span class="SearchResponsesItemChatContext__text">
          {{ text.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ForumResponseModel } from '@/models/forum/forumResponse'
import ForumResponseBodyTextOutput from '@/components/pages/forum/response/body/text/ForumResponseBodyTextOutput.vue'

export default {
  name: 'SearchResponsesItemChatText',
  components: { ForumResponseBodyTextOutput },
  props: {
    result: { type: Object, required: true }
  },
  computed: {
    textList() {
      const list = []
      if (this.result?.highlight?.text?.length) {
        this.result.highlight?.text.forEach((text) => {
          const response = ForumResponseModel.parseFromApi({
            response: {
              ...this.result.response,
              text
            },
            chatId: this.result?.chat?.id,
            threadId: this.result?.thread?.id,
            users: this.result?.users,
            prospects: this.result?.prospects
          })
          list.push({ type: 'text', value: response.mentionProcessedText })
        })
      }
      if (this.result?.highlight?.translates?.length) {
        this.result.highlight.translates.forEach((text) => {
          const response = ForumResponseModel.parseFromApi({
            response: this.result.response,
            chatId: this.result?.chat?.id,
            threadId: this.result?.thread?.id,
            users: this.result?.users,
            prospects: this.result?.prospects
          })
          response.translation.text = text
          list.push({ type: 'translation', value: response.mentionProcessedTranslation })
        })
      }
      if (this.result?.highlight?.transcribes?.length) {
        this.result.highlight.transcribes.forEach((text) => {
          list.push({ type: 'transcription', value: text })
        })
      }
      if (!list.length) {
        const response = ForumResponseModel.parseFromApi({
          response: this.result.response,
          chatId: this.result?.chat?.id,
          threadId: this.result?.thread?.id,
          users: this.result?.users,
          prospects: this.result?.prospects
        })
        list.push({ type: 'text', value: response.mentionProcessedText })
      }
      return list
    }
  }
}
</script>

<style scoped lang="scss">
.SearchResponsesItemChatText {
}
</style>
